import { Component } from '@angular/core';
import { ModificationCommonService } from '../../services/modification-common.service';
import { ConstantService } from '../../services/constant.service';
import { UtilService } from '../../services/util.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { FinBoxStatusReq, VendorStatusReq } from '../../models/request.model';
import { UserSessionService } from '../../services/user-session.service';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EncryptionService } from '../../services/encryption.service';



@Component({
  selector: 'app-loader',
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.less'
})
export class LoaderComponent {

    successParam!: string;
    sessionIdParam!: string;
    manuallyParam!: string;
    camsMode!: string;
    ecresParam : any = '';

  constructor(
    private constantService: ConstantService,
    private utilService: UtilService,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private userSessionService : UserSessionService,
    private _snackbar: MatSnackBar,
    private encryptionService: EncryptionService,
  ) {
    
//   const manuallyParam = router.queryParamMap.get('manually');
      this.camsMode = sessionStorage.getItem("camsMode") || '';

      this.activatedRoute.queryParams?.subscribe((params: any) => {
          if (params?.ecres != null && params?.ecres != undefined) {
            this.sessionIdParam = sessionStorage.getItem('sessionId') || ''
            this.ecresParam = decodeURIComponent(window.location.href.split('?')[1])
            sessionStorage.setItem('ecresParam',this.ecresParam)
            this.getVendorStatus();
        } else if (params.success == 'true' && params?.session_id != null && params?.session_id != undefined) {
            this.successParam = params?.success || 'false';
            this.sessionIdParam = params?.session_id || '';
            this.getVendorStatus();
        } else {
            router.navigate(['/derivative/proof-selection'], { queryParams: { camsMode: this.camsMode } });
        }
          
// if (params.success == 'false' || params.session_id == "" || params.session_id == undefined || params.session_id  == null) {
//     router.navigate(['/derivative/proof-selection'], { queryParams: { camsMode: camsMode } });
//   }else if (params.session_id) {
//     this.getVendorStatus(params.success, params.session_id);
//     }
  });
}

async getFinBoxStatus(isSuccess: boolean, session_id: string) {
    const appSource: string  = this.userSessionService.getUserSessionData().appSource
    const clientCode: string = this.userSessionService.getUserSessionData().clientCode
    const ip :string = this.userSessionService.getUserSessionData().ip
    const salarySlab: any = JSON.parse(localStorage.getItem('salarySlab') || '');
    //clientCode + appSource (UPPER CASE) + sessionId + incomeSlab
    // clientCode + appSource (UPPER CASE) + ipAddress + sessionId + incomeSlab + vendorType + isNameMatch + isLastAttempt + isFinboxSessionSuccess
    const vendorType = sessionStorage.getItem('vendorType') || ''
    const parameter = clientCode + appSource + ip + session_id + salarySlab.values + vendorType + false + this.utilService.checkSumDate;
    const finBoxStatusReq: FinBoxStatusReq = {
        ipAddress: this.userSessionService.getUserSessionData().ip,
        appSource: appSource,
        checkSumValue: this.utilService.GenerateCheckSum(parameter),
        clientCode: clientCode,
        incomeSlab: salarySlab.values,
        isNameMatch: false,
        sessionId: session_id,
        isLastAttempt: false,
        isFinboxSessionSuccess: vendorType=="FINBOX" ? true : false,
        vendorType : vendorType
    };

    this.commonService.FinBoxStatus2(finBoxStatusReq).subscribe({next: (response)=>{
      const status = response.status;
        if (status == 1) {
            this.router.navigateByUrl('/derivative/successfull-request');
        } else if (status == 0 || status == 2|| status == 3) {
             this.router.navigate(['/derivative/missing-details'], {
                 queryParams: { session_id: session_id, response: JSON.stringify(response.data), success : isSuccess }
             });
        } else if (status == 4) {
            this.router.navigate(['/derivative/loader-with-time'], {
                queryParams: { session_id: session_id, success : isSuccess }
            });
        }
    },error:(err)=>{
        const status = err.error.status
        if (status == 0 || status == 2|| status == 3) {
            this.router.navigate(['/derivative/missing-details'], {
                queryParams: { session_id: session_id, response: JSON.stringify(err.error) }
            });
       } else if (status == 4) {
           this.router.navigate(['/derivative/loader-with-time'], {
               queryParams: { session_id: session_id }
           });
        }
        else if (status == 6) {
            this._snackbar.openFromComponent(SnackbarComponent, {
                data: [err.error.message],
                duration: this.constantService.snackBarDuration,
                panelClass: ['failed-popup']
            });
            this.router.navigateByUrl('/derivative/fail-page');
        }
    }})
}
    
    async getVendorStatus() {
    const appSource: string  = this.userSessionService.getUserSessionData().appSource
    const clientCode: string = this.userSessionService.getUserSessionData().clientCode
        const salarySlab: any = JSON.parse(localStorage.getItem('salarySlab') || '');
        const vendorType = sessionStorage.getItem('vendorType') ||''
        //clientCode + appSource (UPPER CASE) + sessionId + incomeSlab
        const parameter = clientCode + appSource + this.userSessionService.getUserSessionData().ip + this.sessionIdParam + salarySlab.values + vendorType + false + this.utilService.checkSumDate;

    const vendorStatusReq: VendorStatusReq = {
        ipAddress: this.userSessionService.getUserSessionData().ip,
        appSource: appSource,
        checkSumValue: this.utilService.GenerateCheckSum(parameter),
        clientCode: clientCode,
        incomeSlab: salarySlab.values,
        isNameMatch: false,
        sessionId: this.sessionIdParam,
        isLastAttempt: false,
        isFinboxSessionSuccess: vendorType == "FINBOX" ? true : false,
        vendorType: vendorType,
        vendorRedirectPayload: this.ecresParam
    };
    this.commonService.getVendorStatus(vendorStatusReq).subscribe({next: (response)=>{
      const status = response.status;
        if (status == 1) {
            this.router.navigateByUrl('/derivative/successfull-request');
        } else if (status == 0 || status == 2|| status == 3) {
             this.router.navigate(['/derivative/missing-details'], {
                 queryParams: { session_id: this.sessionIdParam, response: JSON.stringify(response.data) }
             });
        } else if (status == 4) {
            this.router.navigate(['/derivative/loader-with-time'], {
                queryParams: { session_id: this.sessionIdParam }
            });
        }
    }, error: (err) => {
        const status = err.error.status
        if (status == 0 || status == 2 || status == 3 || status == 7 || status == 8 ||  status == 9) {
            this.router.navigate(['/derivative/missing-details'], {
                queryParams: { session_id: this.sessionIdParam, response: JSON.stringify(err.error) }
            });
        } else if (status == 4) {
           this.router.navigate(['/derivative/loader-with-time'], {
               queryParams: { session_id: this.sessionIdParam }
           });
        }
        else if (status == 6) {
            this._snackbar.openFromComponent(SnackbarComponent, {
                data: [err.error.message],
                duration: this.constantService.snackBarDuration,
                panelClass: ['failed-popup']
            });
            this.router.navigateByUrl('/derivative/fail-page');
        }
    }})
}
}
